<template>
  <div class="index-content">
    <div class="f-row">
      <Breadcrumb
        separator=">"
        class="breadcrumb_zdy"
      >
        当前位置:
        <BreadcrumbItem :to="{name: 'WorkBench'}">工作台Max</BreadcrumbItem>
        <BreadcrumbItem>信息列表页</BreadcrumbItem>
      </Breadcrumb>
      <div>
        <a @click="$router.go(-1)"><i class="iconfont-sm">&#xe661;</i> 返回上一级页面</a>
      </div>
    </div>
    <div class="feed-list">
      <p v-if="list[0]">关于“{{list[0].app_layer_tag_name || list[0].entity_short_name}}”的信息</p>
      <div class="list">
        <Table
          :columns="list_columns"
          :data="list"
        ></Table>
        <div
          class="page clear"
          v-if="total > 20"
        >
          <Page
            :total="total"
            :page-size="20"
            :current="params.page"
            class="page_list"
            show-total
            show-elevator
            ref="pages"
            @on-change="handleChangePage"
          />
        </div>
        <Spin
          fix
          v-if="loading"
        >
          <Icon
            type="ios-loading"
            size=18
            class="demo-spin-icon-load"
          ></Icon>
          <div>Loading</div>
        </Spin>
      </div>
    </div>
  </div>
</template>
<script>
import { getContentByCard } from "../../service"
import filter from 'js/filter'
export default {
  data() {
    return {
      loading: false,
      filter: filter,
      total: 0,
      params: {
        card_type: 2,
        c_id: 24,
        user_key: this.$store.state.user_key,
        page: 1
      },
      list: [],
      content_type_list: [
        { id: '0', name: '快讯' },
        { id: '1', name: '报告' },
        { id: '2', name: '专题' },
        { id: '3', name: '政策' },
        { id: '4', name: '文章' },
        { id: '5', name: '活动' }
      ],
      list_columns: [
        {
          title: '发布时间',
          align: 'center',
          width: 180,
          render: (h, params) => {
            return h('span', filter.time_moment(params.row.c_publish_time))
          }
        },
        {
          title: '类型',
          align: 'center',
          width: 80,
          render: (h, params) => {
            return h('span', filter.dealName(params.row.content_type, this.content_type_list))
          }
        },
        {
          title: '标题',
          align: 'center',
          render: (h, params) => {
            return h('a', {
              on: {
                click: () => {
                  this.goDetail(params.row.content_uid, params.row.content_type, params.row.forum_src_url, params.row.content_id)
                }
              },
              class: {
                'dec-clamp': true
              },
              domProps: {
                innerHTML: params.row.content_title
              }
            })
          }
        }
      ],
    }
  },
  methods: {
    async getContentByCard() {
      let res = await getContentByCard(this.params, error => {
        this.$Message.error("请求错误！")
      })
      if (res.status == "success") {
        this.$set(this.$data, "list", res.res)
        if (this.params.page == 1) this.$set(this.$data, "total", res.count)
      } else {
        this.$Message.error(res.message)
      }
    },
    handleChangePage(val) {
      this.params.page = val
      this.getContentByCard()
      $('html, body').animate({
        scrollTop: 0
      }, 200)
    },
    goDetail(uid, type, src) {
      if (type == 0) {
        const { href } = this.$router.resolve({
          name: "NewsDetail",
          params: { uid: uid }
        });
        window.open(href, "_blank");
      } else if (type == 1) {
        const { href } = this.$router.resolve({
          name: "ReportDetail",
          params: { uid: uid }
        });
        window.open(href, "_blank");
      } else if (type == 2) {
        const { href } = this.$router.resolve({
          name: "SpecialDetail",
          params: { uid: uid }
        });
        window.open(href, "_blank");
      } else if (type == 3) {
        const { href } = this.$router.resolve({
          name: "PolicyDetail",
          params: { uid: uid }
        });
        window.open(href, "_blank");
      } else if (type == 4) {
        window.open(this.$store.state.index2_path + '/' + id);        
      } else if (type == 5) {
        window.open(filter.page(src), "_blank");
      }
    }
  },
  created() {
    this.params.card_type = this.$route.query.card_type
    this.params.c_id = this.$route.query.c_id
    this.getContentByCard()
  }
}
</script>
<style  lang="stylus" scoped>
@import '~styles/common.stylus'
.index-content
  margin 0 auto
  width 1200px
  padding 16px 0 20px
  .feed-list
    width 740px
    margin 16px auto 0
    > p
      font-size 18px
      font-weight 600
      commonColor(#fff, rgba(51, 51, 51, 1))
    .list
      margin-top 16px
      >>> .ivu-table-wrapper
        .ivu-table
          tr
            th:first-of-type
            td:first-of-type 
              text-align center !important
              .ivu-table-cell
                padding-left: 10px
            td:last-of-type 
              text-align left
              .ivu-table-cell
                padding 0 50px
          .ivu-table-tbody .ivu-table-row:nth-of-type(2n)
            commonBgColor(#2A2F42, #F8F8F8)
</style>